import { motion } from "framer-motion";
import { IMG } from "../config";
import { ChapterHead } from "./ChapterHead";

export const Beach = ({ t }) => (
    <section data-testid="beach-section" className="relative overflow-hidden py-20 sm:py-28">
        <span aria-hidden className="font-display pointer-events-none absolute -right-6 top-6 z-0 select-none text-[16rem] font-black leading-none text-[rgba(242,50,24,0.08)] sm:text-[22rem]">01</span>
        <div className="relative z-10 mx-auto grid max-w-7xl gap-12 px-5 sm:px-6 lg:grid-cols-2 lg:gap-16">
            <div className="flex flex-col justify-center">
                <ChapterHead chapter={t.beach.chapter} label={t.beach.label} title={t.beach.title} />
                <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.7, delay: 0.15 }}
                    className="max-w-lg text-sm leading-relaxed text-[#1b0b06]/70 sm:text-base"
                >
                    {t.beach.text}
                </motion.p>
                <div className="mt-10 grid grid-cols-3 gap-4">
                    {t.beach.stats.map(([num, label], i) => (
                        <motion.div
                            key={label}
                            initial={{ opacity: 0, y: 24 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.6, delay: i * 0.12 }}
                            data-testid={`beach-stat-${i}`}
                            className="rounded-2xl border border-[#1b0b06]/10 bg-white/60 p-4"
                        >
                            <p className="font-display text-2xl font-black text-[#f23218] sm:text-3xl">{num}</p>
                            <p className="mt-1 text-xs font-semibold uppercase tracking-wide text-[#1b0b06]/60">{label}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
            <div className="relative">
                <motion.div
                    initial={{ opacity: 0, x: 60 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                    className="relative z-10 overflow-hidden rounded-3xl shadow-2xl"
                >
                    <img src={IMG.exterior} alt="Matianellu Hostel" className="h-[420px] w-full object-cover sm:h-[520px]" />
                </motion.div>
                <motion.div
                    initial={{ opacity: 0, y: 30, rotate: -4 }}
                    whileInView={{ opacity: 1, y: 0, rotate: -4 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{ duration: 0.8, delay: 0.3 }}
                    className="absolute -bottom-8 -left-4 z-20 w-40 overflow-hidden rounded-2xl border-4 border-[#fbf3e8] shadow-xl sm:-left-10 sm:w-52"
                >
                    <img src={IMG.room} alt="Quarto do hostel" className="h-32 w-full object-cover sm:h-40" />
                </motion.div>
            </div>
        </div>
    </section>
);
